import React from 'react';
import { toast } from 'react-toastify';

// Global error handler
export const handleError = (error) => {
  console.error('Global error:', error);
  toast.error(error.message || 'An unexpected error occurred');
};

// Error boundary component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    handleError(error);
  }

  render() {
    if (this.state.hasError) {
      return <div>Something went wrong. Please try refreshing the page.</div>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary; 